<template>
  <div class="filters">
    <div
      v-if="filterTypes.length > 0"
      class="row no-gutters filter-menu"
      v-click-outside="closeFilterMenu"
    >
      <div class="filter-menu-inner col-12">
        <a class="clear-filters" href="#" @click.prevent="removeAllFilters"
          >Clear All</a
        >
        <ContextMenu
          id="filter-menu-dropdown"
          :items="filterMenuItems"
          align="left"
        >
          <div class="filter-menu-dropdown-toggle clearfix">
            <icon icon="plus" class="svg-icon" />
            <span class="text">Filter</span>
          </div>
        </ContextMenu>
      </div>
    </div>

    <div v-if="hasActiveFilters" class="active-filters">
      <a
        v-for="(filter, i) in activeFilters"
        :key="i"
        class="pill"
        href="#"
        @click.prevent="removeFilter(filter)"
        title="Remove Filter"
      >
        <span class="text">{{ filter.label }}</span>
        <icon icon="remove" class="icon" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    currentFilters: { type: Array },
    filterTypes: { type: Array },
  },
  data() {
    return {
      currentFilterType: null,
    };
  },
  computed: {
    selectedFilterType() {
      return this.filterTypes.length == 1
        ? this.filterTypes[0]
        : this.currentFilterType;
    },
    filterTypesMenu() {
      var filterTypes = this.filterTypes || [];
      return filterTypes.map((type) => {
        return {
          label: type.label,
          action: () => {
            this.selectFilterType(type);
          },
        };
      });
    },
    filterValues() {
      var values = [];
      if (!!this.selectedFilterType) {
        this.filterTypes.forEach((type) => {
          if (type.key == this.selectedFilterType.key) {
            values = type.options || [];
          }
        });
      }
      return values;
    },
    filterValuesMenu() {
      var menu = [];
      if (this.filterTypes.length > 1) {
        menu.push({
          label: "< Go Back",
          action: () => {
            this.deselectFilterType();
          },
        });
      }
      this.filterValues.forEach((option) => {
        if (
          _.has(option, "condition") &&
          !this.filterConditionMet(option.condition)
        ) {
          return;
        }
        let opt = _.cloneDeep(option);
        if (!option.disabled) {
          opt.action = () => {
            this.addFilter(option);
          };
        }
        menu.push(opt);
      });
      return menu;
    },
    filterMenuItems() {
      return !!this.selectedFilterType
        ? this.filterValuesMenu
        : this.filterTypesMenu;
    },
    activeFilters() {
      return this.currentFilters.filter((f) => {
        return this.isValidFilterType(f.type);
      });
    },
    hasActiveFilters() {
      return this.activeFilters.length > 0;
    },
  },
  methods: {
    selectFilterType(type) {
      this.currentFilterType = type;
    },
    deselectFilterType() {
      this.currentFilterType = null;
    },
    closeFilterMenu() {
      this.deselectFilterType();
      $("#filter-menu-dropdown").dropdown("hide");
      $("#filter-menu-dropdown").removeClass("show");
    },
    isActiveFilter(type, value) {
      var result = false;
      if (this.hasActiveFilters) {
        this.currentFilters.forEach((f) => {
          if (f.type == type && f.value == value) {
            result = true;
          }
        });
      }
      return result;
    },
    addFilter(filter) {
      var type = this.selectedFilterType.key;
      if (!this.isActiveFilter(type, filter.value)) {
        this.$emit("add-filter", type, filter.value);
        this.closeFilterMenu();
      }
    },
    removeFilter(filter) {
      if (this.isActiveFilter(filter.type, filter.value)) {
        this.$emit("remove-filter", filter.type, filter.value);
      }
    },
    removeAllFilters() {
      this.$emit("remove-all-filters");
    },
    isValidFilterType(type) {
      return (
        this.filterTypes.filter((f) => {
          return f.key == type;
        }).length > 0
      );
    },
    filterConditionMet(condition) {
      if (!!condition.value) {
        return this.isActiveFilter(condition.type, condition.value);
      } else {
        return (
          this.currentFilters.filter((f) => f.type == condition.type).length ==
          0
        );
      }
    },
  },
  mounted() {
    $("#filter-menu-dropdown .dropdown-menu").on("click.bs.dropdown", (e) => {
      e.stopPropagation();
    });
  },
};
</script>
